/* ════════════ DRIFTING RUNES ════════════
   The Odin dossier's atmosphere: elder futhark runes rising slowly
   through the dark like sparks off a forge. */

import { fillBars } from "./statbars";
import { onPage } from "./router";

const REDUCED = matchMedia("(prefers-reduced-motion: reduce)").matches;

function runes(signal: AbortSignal) {
  const c = document.querySelector<HTMLCanvasElement>("#runes")!;
  const ctx = c.getContext("2d")!;
  const RUNES = "ᚠᚢᚦᚨᚱᚲᚷᚹᚺᚾᛁᛃᛇᛈᛉᛋᛏᛒᛖᛗᛚᛜᛞᛟ";
  const colors = ["#00ffa3", "#00ffa3", "#7affd0", "#2bd9ff"];

  type Rune = { x: number; y: number; vy: number; ch: string; col: string; size: number; alpha: number };
  let runes: Rune[] = [];

  const make = (anywhere = false): Rune => ({
    x: Math.random() * c.width,
    y: anywhere ? Math.random() * c.height : c.height + 18,
    vy: 0.12 + Math.random() * 0.3,
    ch: RUNES[(Math.random() * RUNES.length) | 0]!,
    col: colors[(Math.random() * colors.length) | 0]!,
    size: Math.random() > 0.85 ? 18 : 13,
    alpha: 0.2 + Math.random() * 0.35,
  });

  const seed = () => {
    c.width = innerWidth;
    c.height = innerHeight;
    const count = Math.min(40, Math.floor((c.width * c.height) / 42000));
    runes = Array.from({ length: count }, () => make(true));
  };
  seed();
  addEventListener("resize", seed, { signal });

  const draw = () => {
    ctx.clearRect(0, 0, c.width, c.height);
    for (const r of runes) {
      ctx.globalAlpha = r.alpha;
      ctx.fillStyle = r.col;
      ctx.font = `${r.size}px "IBM Plex Mono", monospace`;
      ctx.fillText(r.ch, r.x | 0, r.y | 0);
    }
    ctx.globalAlpha = 1;
  };

  if (REDUCED) {
    draw();
    return;
  }
  const tick = () => {
    if (signal.aborted) return;
    for (const r of runes) {
      r.y -= r.vy;
      if (r.y < -20) Object.assign(r, make());
    }
    draw();
    requestAnimationFrame(tick);
  };
  tick();
}

onPage((signal) => {
  runes(signal);
  fillBars();
});
